import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useRootContext } from '@/store/RootContext';
import { Loader } from '@/component/Loader';
import { useCurrentUserAccess } from '@/store/currentUser';
import { ROUTE_PATH } from '@/constants/routePaths';

export const SuperAdminRoute = (): JSX.Element => {
  const { isAuthenticated, loading } = useRootContext();
  const { isSuperAdmin } = useCurrentUserAccess();
  const location = useLocation();

  if (loading) return <Loader />;

  if (!isAuthenticated) {
    return <Navigate to={{ pathname: ROUTE_PATH.LOGIN }} state={{ from: location }} />;
  }
  if (!isSuperAdmin) {
    return <Navigate to={{ pathname: '/' }} state={{ from: location }} />;
  }

  return <Outlet />;
};
